// @scripts
import { config } from '../config';
import { environment } from '../core';
import { printError } from '.';

export const CATEGORY = {
    ACOUSTICAL: 'acoustical',
    ADJUSTABLE: 'adjustable',
    COMBINATION: 'combination',
    HURRICANE: 'hurricane',
    STATIONARY: 'stationary',
    WINDDRIVEN: 'windDriven'
};

export const getCategoryType = (category) => {
    const categoryValue = {
        [CATEGORY.ACOUSTICAL]: 1,
        [CATEGORY.ADJUSTABLE]: 2,
        [CATEGORY.COMBINATION]: 4,
        [CATEGORY.HURRICANE]: 5,
        [CATEGORY.STATIONARY]: 7,
        [CATEGORY.WINDDRIVEN]: 8
    };
if(!category) category = 0;
    if (!Object.prototype.hasOwnProperty.call(categoryValue, category)) {
        printError('CategoryType is not recogniced', environment.isUnitTest);
    }

    return categoryValue[category];
};

const getDefaultValue = (prop) => config.masterData.defaultValues[prop];


export default (searchState, category) => {
    const stateHasProp = (prop) => Object.prototype.hasOwnProperty.call(searchState, prop);
    const getValueFromAttr = (prop, attr) => (stateHasProp(prop) && searchState[prop][attr]) || '';
    const getValue = (prop) => (stateHasProp(prop) && searchState[prop].value) || getDefaultValue(prop);

    return ({
            "id" : getCategoryType(category),
            "flow": getValue('flow'),
            "height": getValue('height'),
            "width": getValue('width'),
            "pressure": getValue('pressure'),
            "intakeexhaust": getValue('intakeexhaust'),
            "certification": getValue('certification'),
            "louverDepth": getValue('louverDepth'),
            "material": getValue('material'),
            "bladeType": getValue('bladeType'),
            "wpFactor": getValue('wpFactor'),
            "brand": getValue('brand')
    });
};